"use strict";

var React = require('react');

var PropTypes = require('prop-types');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var Preloader = function Preloader(props) {
  return React.createElement('div', {
    className: props.getClassName('control-preloader')
  });
};

Preloader.displayName = displayNames.PRELOADER;
Preloader.propTypes = {
  /** Set the preloader size and theme.
   * Sizes can be either `tiny`, `small` (default), `medium` and `large`.
   * Themes can be either `standard` (default) and `light`*/
  className: PropTypes.string
};
module.exports = compose(Preloader);